import {takeLatest, put, call, delay, select} from 'redux-saga/effects';
import {AppConst} from '../../constants';
import {tutorialList} from '../../utils/apis';
import {_ToastHandler} from '../../utils/helperFunctions';
import {isWebsite} from '../../utils/responsive';
import {authState} from '../reducers/authSlice';
import {
  onTutorialListEnd,
  onTutorialListFailed,
  onTutorialListSuccess,
} from '../reducers/tutorialListSlice';
import {TutorialListResponse} from '../../types/reducerTypes/tradeTabTypes';
import {IActionType} from '../../types/constantFilesTypes';

const {StoreConstants} = AppConst;

function* tutorialListContact(action: IActionType) {
  try {
    const {userTokens} = yield select(authState);
    const data: TutorialListResponse = yield call(
      tutorialList,
      userTokens,
      action.payload
    );
    yield put(onTutorialListSuccess(data?.data ?? []));
  } catch (error: any) {
    _ToastHandler(error?.response?.data?.message || 'An error occurred', false);
    yield put(onTutorialListFailed(error));
  } finally {
    if (isWebsite()) yield delay(1);
    yield put(onTutorialListEnd());
  }
}

export default function* tutorialListSaga() {
  yield takeLatest(
    `${StoreConstants.TUTORIALS_VIDEO}/onTutorialListStart`,
    tutorialListContact
  );
}
